"use strict";

define('rs/models/link',['rs/models/abstract'], function (AbstractModel) {
  var LinkModel = AbstractModel.extend({
    properties: ['displayName', 'url', 'link'],
    link: true,
    setUrl: function setUrl(url, options) {
      if (_.isString(url)) {
        url = url.trim();
        if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0) {
          url = "http://" + url;
        }
      }
      return this._super(url, options);
    }
  });
  return LinkModel;
});

